import { useMemo, useState } from "react";
import { articles } from "@/mocks/articles";
import { ArticleCard } from "@/components/feature/ArticleCard";

const allTabs = [
  { key: "all", name: "全部" },
  { key: "yule", name: "娱乐八卦" },
  { key: "zongyi", name: "综艺现场" },
  { key: "shehui", name: "社会热点" },
  { key: "wangluo", name: "网络热梗" },
];

export default function FeedSection() {
  const [tab, setTab] = useState("all");
  const [kw, setKw] = useState("");

  const filtered = useMemo(() => {
    let list = tab === "all" ? [...articles] : articles.filter((a) => a.cat === tab);
    if (kw.trim()) {
      const q = kw.trim();
      list = list.filter((a) => a.title.includes(q) || a.excerpt.includes(q) || a.tags.some((t) => t.includes(q)));
    }
    return list;
  }, [tab, kw]);

  return (
    <section aria-labelledby="feed-title">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-primary-500">今日新鲜事</p>
          <h2 id="feed-title" className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            今日瓜田，新鲜开席
          </h2>
        </div>
        <div className="relative w-full md:w-64">
          <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-500" aria-hidden="true"></i>
          <input
            type="search"
            value={kw}
            onChange={(e) => setKw(e.target.value)}
            placeholder="搜索你关心的瓜…"
            className="w-full rounded-full border border-background-300 bg-background-50 py-2.5 pl-10 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-500 focus:border-primary-400"
          />
        </div>
      </div>

      <div className="mt-5 flex flex-wrap items-center gap-2">
        {allTabs.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
              tab === t.key
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
            }`}
          >
            {t.name}
          </button>
        ))}
      </div>

      {filtered.length ? (
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {filtered.map((a) => (
            <ArticleCard key={a.slug} article={a} />
          ))}
        </div>
      ) : (
        <div className="mt-6 flex flex-col items-center justify-center rounded-2xl border border-dashed border-background-300 py-16 text-center">
          <i className="ri-folder-forbid-line text-4xl text-background-400" aria-hidden="true"></i>
          <p className="mt-3 text-sm text-foreground-600">没有找到相关的内容，换个关键词试试吧。</p>
          <button
            type="button"
            onClick={() => {
              setKw("");
              setTab("all");
            }}
            className="mt-4 rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 cursor-pointer"
          >
            查看全部
          </button>
        </div>
      )}
    </section>
  );
}